import { supabase } from "@/integrations/supabase/client";

export async function testIsbndbForSeries(isbn: string) {
  try {
    console.log(`[Test] Checking ISBNdb for ISBN: ${isbn}`);
    
    const { data, error } = await supabase.functions.invoke('test-isbndb-series', {
      body: { isbn }
    });

    if (error) {
      console.error('[Test] Error:', error);
      return null;
    }

    console.log('[Test] ISBNdb response:', data);
    return data;
  } catch (error) {
    console.error('[Test] Exception:', error);
    return null;
  }
}
